module.exports = __webpack_public_path__ + "img/item_fz.71d7963e.png";